<template>
  <div id="login">
    <h2>核销中心</h2>
    <div class="login">
      <div class="field name">
        <img :src="imgPath + 'user.png'" />
        <div class="input">
          <van-field v-model="username" icon="clear" placeholder="用户名" @click-icon="username = ''" />
        </div>
      </div>
      <div class="field password">
        <img :src="imgPath + 'password.png'" />
        <div class="input">
          <van-field
            v-model="password"
            type="password"
            icon="clear"
            placeholder="密码"
            @click-icon="password = ''"
            @keyup.enter="login"
          />
        </div>
      </div>

      <a class="loginBtn" @click="login">立即登陆</a>

      <div class="keep">
        <van-checkbox v-model="checked">记住密码</van-checkbox>
      </div>
    </div>

    <div class="content">
      <h3>使用说明：</h3>
      <p>主办方在后台设置核销管理员用户名、密码，核销管理员在该页面进行登录。登录完成后即可扫码进行核销。</p>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import tool from "../../kits/Tools.js";
import { Field } from "vant";
Vue.use(Field);
import { Checkbox, CheckboxGroup } from "vant";
Vue.use(Checkbox).use(CheckboxGroup);
import { Toast } from "vant";
//保存数据

export default {
  data() {
    return {
      username: "",
      password: "",
      checked: true,
      imgPath: ""
    };
  },
  mounted() {
    this.imgPath = tool.imgPath();
    var username = tool.getCookie("username");
    var password = tool.getCookie("password");
    if (username) {
      this.username = unescape(username)
        .split(" ")
        .join("");
    }
    if (password) {
      this.password = unescape(password)
        .split(" ")
        .join("");
    }
  },
  methods: {
    login() {
      var that = this;
      var option = "name=" + this.username + "&password=" + this.password;
      if (!this.username || !this.password) {
        Toast("用户名和密码不能为空");
        return false;
      }
      this.axios.defaults.withCredentials = true;
      this.axios
        .post(tool.baseUrl() + "/coupon/verify/login", option)
        .then(function(data) {
          console.log(data);
          if (data.data.code == "200") {
            Toast(data.data.message);
            if (that.checked) {
              tool.setCookie(
                "username",
                escape(that.username.split("").join(" ")),
                30
              );
              tool.setCookie(
                "password",
                escape(that.password.split("").join(" ")),
                30
              );
            } else {
              tool.setCookie("username", null, -1);
              tool.setCookie("password", null, -1);
            }
            console.log(document.cookie);
            setTimeout(function() {
              that.$router.push({ path: "/scan" });
            }, 300);
          } else {
            Toast(data.data.message);
          }
        })
        .catch(function() {
          console.log("错误");
        });
    }
  }
};
</script>

<style>
#login {
  min-height: 100%;
  background: #5582e7
    url(https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/img/8ecaff914dfca8cee00e58ecb784971d.jpg)
    no-repeat bottom center;
  -webkit-background-size: 100%;
  background-size: 100%;
  color: #fff;
  padding: 0 18px;
}

#login h2 {
  text-align: center;
  line-height: 80px;
  font-size: 20px;
}

#login .login {
  padding: 35px;
  background: #fff;
  color: #999;
  border-radius: 5px;
  box-shadow: 0 4px 14px 0 #3664d0;
}

#login .field {
  display: flex;
  line-height: 45px;
  border-bottom: 1px solid #adadad;
  margin-bottom: 20px;
}

#login .field img {
  height: 26px;
  margin-top: 9px;
  margin-right: 10px;
}

#login .input {
  flex: 1;
}

.loginBtn {
  line-height: 45px;
  text-align: center;
  background: #4a7ae6;
  color: #fff;
  border-radius: 3px;
  display: block;
  margin-top: 40px;
}

#login .keep {
  margin-top: 10px;
}

#login .van-checkbox__control:checked + .van-icon-success {
  background-color: #4a7ae6;
  border-color: #4a7ae6;
}

#login .content {
  margin-top: 20px;
  line-height: 30px;
}
</style>
